export default __webpack_public_path__ + "dfae6b631d48dae57e4ad8cc8ccc66aa.svg";